import { InputField, LabelField, MyCheckbox, SelectField } from 'components';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { fontConfig } from "theme/fontConfig";

const ClassDetails = ({ formik }) => {
  const handleAgeRangeChange = (text) => {
    const numberText = text.replace(/[^\d-]/g, '');
    if(text.length === 2 && text[1] == '-') {
      formik.setFieldValue('age_range', "0" + text);
    } else if(text.length === 3 && text[2] !== '-' && text[1] !== '-') {
      const firstThreeDigits = parseInt(text.substring(0, 3));
      if (firstThreeDigits < 120) {
        formik.setFieldValue('age_range', text.substring(0, 3) + '-' + text.substring(3, 5));
      }
      if(formik.values?.age_range?.length === 4 && text[2] !== '-') {
        formik.setFieldValue('age_range', text);
      }
    } else if(text.length > 3) {
      const firstThreeDigits = text.split('-')[0]
      const lastThreeDigits = text.split('-')[1];
      if(lastThreeDigits <= 120) {
        formik.setFieldValue('age_range', firstThreeDigits + "-" + lastThreeDigits);
      }
    }
    else {
      formik.setFieldValue('age_range', numberText);
    }
  }

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  return (
    <>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            formik={formik}
            mandatory={!formik.values?.infiniteParticipants}
            title="Class Capacity"
            name="class_capacity"
            placeholder="Class Capacity"
            checkValidation={true}
            handleChange={(e) => {
              const value = e?.target?.value.match(regex)[0];
              if (parseFloat(value) > 10000) return;
              formik.setFieldValue('class_capacity', value);
            }}
            value={formik.values?.class_capacity}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            disabled={formik.values?.infiniteParticipants}
            inputClassName="class_capacity_input"
          />
        </Col>
        <Col className="col-sm-5 d-flex align-items-center mt-5">
          <MyCheckbox
            title="No Limit"
            checked={formik.values?.infiniteParticipants}
            handlechange={() => {
              formik.setFieldValue(
                'infiniteParticipants',
                !formik.values?.infiniteParticipants
              );
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            formik={formik}
            mandatory={true}
            title="Age Range"
            name="age_range"
            placeholder="01-120"
            checkValidation={true}
            // maxLength=""
            handleChange={(e) => handleAgeRangeChange(e?.target?.value)}
            value={formik.values?.age_range}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          />
        </Col>
        <Col className="col-sm-6">
          <SelectField
            titleStyle={{
              fontFamily: fontConfig.GeneralSelectFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={false}
            {...{
              formik,
              title: 'Grade',
              name: 'grade',
              items: [
                'Infant/Toddler Program',
                'Preschool/Pre-K',
                'Kindergarten',
                'Grade 1',
                'Grade 2',
                'Grade 3',
                'Grade 4',
                'Grade 5',
                'Grade 6',
                'Grade 7',
                'Grade 8',
                'Grade 9',
                'Grade 10',
                'Grade 11',
                'Grade 12',
                'College/University',
                'Graduate School',
                'Adult Education',
                'Other'
              ],
              value: formik.values.grade,
              placeholder: 'Grade',
              checkValidation: true,
            }}
            onClick={(data) => formik.setFieldValue('grade', data)}
          />
        </Col>
      </Row>
    </>
  );
};

export default ClassDetails;
